import { query } from "../components"

const getCountries = () => {
  return query(`{
    categories {
      id,
      name 
    }
  }`)
}

const getProducts = (limit) => {
  return query(`{
        products(limit : ${limit}) {
          id,
          fullName,  
          fixedPrice,
          isVariablePrice,
          minVariablePrice,
          maxVariablePrice,
          urlImage,
          requireMail,
          requirePhone,
          requireOther,
          currency
        }
      }`)
}

const getProduct = async (productId) => {
  const { products } = await query(`{
        products(filter : { id : ${productId}}) {
          id,
          categories { id, name },
          countries { id, name },
          fullName,  
          fixedPrice,
          isVariablePrice,
          minVariablePrice,
          maxVariablePrice,
          urlImage,
          requireMail,
          requirePhone,
          requireOther,
          currency,
          recommendedAmounts
        }
      }`)
    return products[0];
}

const getCountryProducts = async (countryId) => {
  try {
    let { countries } = await query(`{
        countries (filter : { id : "${countryId}" }){
          name,
          products {
            id,
            fullName,  
            fixedPrice,
            isVariablePrice,
            minVariablePrice,
            maxVariablePrice,
            urlImage,
            requireMail,
            requirePhone,
            requireOther,
            currency
          }
        }
      }`)
    if (countries[0]) return countries[0].products;
    throw new Error('Country not found');
  } catch (e) {
    throw e;
  }
}

const getCategoryProducts = async (categoryId) => {
  try {
    let { categories } = await query(`{
        categories (filter : { id : "${categoryId}" }){
          name,
          products {
            id,
            fullName,  
            fixedPrice,
            isVariablePrice,
            minVariablePrice,
            maxVariablePrice,
            urlImage,
            requireMail,
            requirePhone,
            requireOther,
            currency
          }
        }
      }`)
    if (categories[0]) return categories[0].products;
    throw new Error('Country not found');
  } catch (e) {
    throw e;
  }
}

const getBrands = (limit, country = undefined, category = undefined) => {
  let filter = [];
  if(country){
    filter.push(`country : "${country}"`); 
  }
  if(category){
    filter.push(`category : "${category}"`); 
  }
  return query(`{
    catalog(limit: ${limit} ${filter.length? ', filter : {' + filter.join(', ') + '}' : ''}) {
      variantID,
      brandName,
      brandImageURL
    }
  }`)
}

const getBrand = async (id) => {
  const { catalog } = await query(`{
    catalog(filter : { variantProductID : "${id}"}) {
      variantID,
      brandName,
      brandImageURL,
      products {
        id,
        variantProductId,
        available
        description,
        categories { id, name },
        countries { id, name },
        fullName,  
        isVariablePrice,
        fixedPrice,
        minVariablePrice,
        maxVariablePrice,
        eurFixedPrice,
        eurMinVariablePrice,
        eurMaxVariablePrice,
        urlImage,
        requireMail,
        requirePhone,
        requireOther,
        currency,
        redeemInstructions,
        tc,
        recommendedAmounts
      }
    }
  }`)
  if(catalog.length)
    return catalog[0]
  else throw new Error("Could not find brand");
} 

const getSimilar = async (productId) => {
  const { categories, countries } = await getProduct(productId);
  if(!categories.length || !countries.length)
    throw new Error("Could not find similar brands");
  const { catalog } =  await query(`{
    catalog(filter : { category : "${categories[0].id}", country : "${countries[0].id}" }) {
      variantID,
      brandName,
      brandImageURL
    }
  }`)  
  
  const start = Math.round(Math.random(catalog.length-4));
  return catalog.slice(start, start + 4);
}

const getFeaturedBrands = async (limit, country) => {
  const { catalog } =  await query(`{
    catalog ${ country ? `(filter : { country :  "${country}"})` : ''}{
      variantID,
      brandName,
      brandImageURL,
      products {
        minVariablePrice,
        fixedPrice
        isVariablePrice,
        currency
      }
    }
  }`)  
  
  return catalog ? catalog.slice(0, 3) : [];
}

const searchBrands = async (name, country, items) => {
  try {
    let filter = [];
    filter.push(`search : "${name}"`); 
    if(country){
      filter.push(`country : "${country}"`); 
    }
    var { catalog } = await query(`{
      catalog(filter : {${filter.join(', ')}}) {
        variantID,
        brandName,
        brandImageURL,
        products {
          minVariablePrice,
          fixedPrice
          isVariablePrice,
          currency
        }
      }
    }`)
    if(items)
      return catalog.slice(0, items)
    return catalog;
  } catch (e){
    throw e
  }
}

const Bitcou = {
  getCountries,
  getProducts,
  getBrands,
  getBrand,
  getSimilar,
  getFeaturedBrands,
  getCountryProducts,
  getCategoryProducts,
  searchBrands
}

export default Bitcou;